/**
 * Notas a los estados financieros.
 *
 * Sustituyen a la hoja de texto suelto del Excel: cada observación lleva
 * responsable, estado y qué estado financiero afecta, de modo que lo pendiente
 * se ve en la plataforma en vez de recordarlo alguien.
 */

import { StatusBadge } from "../../components/StatusBadge";
import type { StatusTone } from "../../components/tones";
import { useClosing } from "./closingContext";
import { StatementHead } from "./shared";

const TONE: Record<string, StatusTone> = {
  pendiente: "serious",
  en_revision: "warning",
  resuelto: "good",
};

export function ClosingNotes() {
  const { package: pkg } = useClosing();

  return (
    <>
      <StatementHead
        title="Notas a los Estados Financieros"
        homologation={pkg.homologation.closing_notes}
      />

      <div className="card">
        <div className="table-wrap documento">
          <table>
            <thead>
              <tr>
                <th scope="col">Nota</th>
                <th scope="col">Observación</th>
                <th scope="col">Afecta a</th>
                <th scope="col">Estado</th>
              </tr>
            </thead>
            <tbody>
              {pkg.notes.length === 0 && (
                <tr>
                  <td colSpan={4} className="muted">
                    Sin observaciones registradas para este cierre.
                  </td>
                </tr>
              )}
              {pkg.notes.map((note) => (
                <tr key={note.id}>
                  <td className="mono">{note.id}</td>
                  <td>
                    <b>{note.title}</b>
                    <div className="small muted">{note.detail}</div>
                    {note.resolution && (
                      <div className="small">Acción: {note.resolution}</div>
                    )}
                  </td>
                  <td className="small">{note.affects}</td>
                  <td>
                    <StatusBadge tone={TONE[note.status] ?? "neutral"}>
                      {note.status.replace("_", " ")}
                    </StatusBadge>
                    <div className="small muted">{note.responsible}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
